import React, { useState, useEffect } from "react";
import TableLoaderEffect from "../../constant/TableLoader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  approveComplianceList,
  bulkApproveCompliance,
} from "../../../services/SIService";


const PendingCompliancePage = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCompliance, setSelectedCompliance] = useState([]);
  const navigate = useNavigate()

  useEffect(() => {
    setIsLoading(true);
    approveComplianceList()
      .then((resp) => {
        setData(resp.data.results);
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.message);
          setIsLoading(false);
        } else {
          console.log(error);
        }
      });
  }, []);

  const toggleCheckbox = (id) => {
    setSelectedCompliance((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((item) => item !== id);
      } else {
        return [...prevSelected, id];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedCompliance.length === data.length) {
      setSelectedCompliance([]);
    } else {
      setSelectedCompliance(data.map((item) => item.id));
    }
  };

  const handleApprove = () => {
    bulkApproveCompliance({ compliance_id_list: selectedCompliance })
      .then((resp) => {
        setData(data.filter((item) => !selectedCompliance.includes(item.id)));
        setSelectedCompliance([]);
        toast.success(resp.data.message);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="tbl-caption d-flex justify-content-between text-wrap flex-column  flex-sm-row align-items-start align-items-sm-center p-3">
                  <div className="d-flex  align-items-center">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-circle"
                      onClick={() => navigate("/dashboard")}
                    >
                      <i className="fa-solid fa-arrow-left"></i>
                    </button>
                    <h4 className="mb-0 ms-2">Pending Compliance</h4>
                  </div>
                  <div className="d-flex align-items-start align-items-sm-center flex-column flex-sm-row">
                    <span className="badge badge-lg badge-circle badge-outline-info me-3">
                      selected {selectedCompliance.length}
                    </span>
                    {selectedCompliance.length > 0 && <button className="btn btn-sm btn-primary" onClick={handleApprove}>
                      Approve
                    </button>}
                  </div>
                </div>
                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                  <div
                    id="employee-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="empoloyees-tblwrapper"
                      className="table ItemsCheckboxSec dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th>
                            <div className="form-check custom-checkbox checkbox-primary">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={selectedCompliance.length === data.length && data.length !== 0}
                                onChange={handleSelectAll}
                              />
                            </div>
                          </th>
                          <th>Reference Number</th>
                          <th>Department</th>
                          <th>Unit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <TableLoaderEffect colLength={7} />
                        ) : (
                          data.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <div className="form-check custom-checkbox checkbox-primary">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={selectedCompliance.includes(item.id)}
                                    onChange={() => toggleCheckbox(item.id)}
                                  />
                                </div>
                              </td>

                              <td>{item.reference_number}</td>
                                <td>{item.department?.name || ""}</td>
                                <td>{item.unit?.name || ""}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingCompliancePage;
